Customer.Ticket ||= {}

class Customer.Ticket.PriorityView extends Backbone.View
  tagName: 'span'
  template: JST["backbone/templates/customer/ticket/header/priority"]

  events:
    'change #priority-list': 'onPriority'

  initialize: (@options = {}) ->
    @priorities = {
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four',
      5: 'five',
      6: 'six',
      7: 'seven',
      8: 'eight',
      9: 'nine',
      10: 'ten'
    }
    @model = @options.model

  render: ->
    @isAssignedToMe = @model.attributes.assigned_to_id == Keepcon.currentUser.id
    @$el.html(@template(model: @model, priorities: @priorities, isAssignedToMe: @isAssignedToMe))
    @$el.find('#priority-list').chosen(width: '85px', disable_search_threshold: 5)
    @

  onPriority: (event) =>
    priority = $(event.currentTarget)
    @trigger('priority:changed', priority.val())

  prioritizeSucess: (ticket)=>
    @model = ticket
    @render()
